<template>
  <v-list
    class="permission-list pa-0 ma-0 fonte"
    :class="{ 'permission-list-dark': $theme.dark }"
    dense
    :dark="$theme.dark"
    :light="$theme.light"
    background-color="transparent"
    style="min-height: 20vh; max-height: 90vh; overflow: auto;"
  >
    <template v-for="(permission, i) in showFiltereds">
      <v-list-item
        @click="open(permission)"
        :key="permission._id"
        class="permission-list-item fonte pl-2 pr-1 animate__animated animate__fadeInUp"
      >
        <v-list-item-content>
          <v-list-item-title class="permission-title fonte fonteMini">
            {{ permission.nome }}
          </v-list-item-title>
          <v-list-item-subtitle class="fonteMini">
            <v-chip small class="permission-route-chip">
              Inicia em
              <span class="ml-2 fonte-bold">
                {{ permission.rota_inicial }}
              </span>
            </v-chip>
          </v-list-item-subtitle>
          <v-list-item-subtitle class="permission-subtitle fonteMini">
            Clique para gerenciar
          </v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-action>
          <v-avatar rounded size="36" class="permission-lock">
            <v-icon size="20">mdi-lock-outline</v-icon>
          </v-avatar>
        </v-list-item-action>
      </v-list-item>
      <v-divider class="permission-divider" :key="i"></v-divider>
    </template>
    <v-list-item
      style="min-height: 200px;"
      v-intersect="onIntersect"
    ></v-list-item>
  </v-list>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: {
    filtereds: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      itemsToShow: 12
    };
  },
  computed: {
    ...mapGetters(["get_permission"]),
    showFiltereds() {
      return this.filtereds.slice(0, this.itemsToShow);
    }
  },
  methods: {
    onIntersect() {
      this.itemsToShow += 12;
    },
    open(client) {
      this.$store.commit("set_permission", client);
    }
  }
};
</script>

<style scoped>
.permission-list {
  color: #24352d;
}
.permission-list-item {
  border-radius: 6px;
  min-height: 72px;
  transition: background-color 0.18s ease, color 0.18s ease;
}
.permission-list-item:hover {
  background: rgba(31, 143, 85, 0.08);
}
.permission-title {
  color: #1f2d27;
  font-weight: 700;
}
.permission-subtitle {
  color: #5f6f66 !important;
  font-weight: 600;
}
.permission-route-chip {
  background: #e8f2ed !important;
  border: 1px solid rgba(31, 143, 85, 0.2);
  border-radius: 4px !important;
  color: #0b7c55 !important;
  font-weight: 700;
}
.permission-lock {
  background: #edf3f0 !important;
  color: #8fa39a !important;
}
.permission-lock .v-icon {
  color: #8fa39a !important;
}
.permission-divider {
  border-color: rgba(31, 45, 39, 0.1) !important;
}
.permission-list-dark {
  color: #eef4f1;
}
.permission-list-dark .permission-list-item:hover {
  background: #182229;
}
.permission-list-dark .permission-title {
  color: #f3faf6;
}
.permission-list-dark .permission-subtitle {
  color: #b9c7c0 !important;
}
.permission-list-dark .permission-route-chip {
  background: #123826 !important;
  border-color: #26734d;
  color: #9be7bd !important;
}
.permission-list-dark .permission-lock {
  background: #182229 !important;
  color: #9be7bd !important;
}
.permission-list-dark .permission-lock .v-icon {
  color: #9be7bd !important;
}
.permission-list-dark .permission-divider {
  border-color: #26343c !important;
}
</style>
